module.exports = __webpack_public_path__ + "static/media/ngo.35624cc2.svg";